import deprecatedIncidentService from '../services/deprecatedincident.service';

const deprecatedincidents = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        //create(_, incident) {return deprecatedIncidentService.create(incident);},

        //READ
        get(_, params) {
            return deprecatedIncidentService.get(params.id, params.urlParameters, params.requestId);
        },
        getageing() {
            return deprecatedIncidentService.getAgeing();
        },

        //UPDATE
        //update(_, incident) {return deprecatedIncidentService.update(incident);},

        //DELETE
        //delete(_, id) {return deprecatedIncidentService.delete(id);},
    },
    getters: {},
    mutations: {},
};

export default deprecatedincidents;
